<template>
  <v-container fluid class="mt-2 px-8" style="height: 500px; max-width: 900px; margin-left: auto; margin-right: auto;">
    <v-form v-model="valida" dense class="mt-4">
      <!-- Card principal con el diseño nuevo -->
      <v-card class="radius-card pa-6" elevation="2">
        <!-- Header con icono y título -->
        <div class="d-flex align-center mb-6">
          <div class="icon-circle">
            <v-icon color="white" size="22">fa-solid fa-location-dot</v-icon>
          </div>
          <div class="ml-3">
            <h3 class="radius-title mb-0">{{ $t('components.views.settings.posting_rules.post_radius.publication_radius_title') }}</h3>
            <p class="radius-subtitle mb-0 mt-1">{{ $t('components.views.settings.posting_rules.post_radius.adjust_search_area') }}</p>
          </div>
          <v-spacer></v-spacer>
          <div class="text-right value-container">
            <div class="radius-value">{{ ratio }}</div>
            <div class="radius-unit">{{ $t('components.views.settings.posting_rules.post_radius.kilometers') }}</div>
          </div>
        </div>

        <!-- Marcadores del slider -->
        <div class="slider-markers d-flex justify-space-between mb-1 px-1">
          <span class="marker" :class="{ 'marker-active': ratio >= 1 }">
            <span class="marker-tick"></span>
            <span class="marker-label">1</span>
          </span>
          <span class="marker" :class="{ 'marker-active': ratio >= 100 }">
            <span class="marker-tick"></span>
            <span class="marker-label">100</span>
          </span>
          <span class="marker" :class="{ 'marker-active': ratio >= 200 }">
            <span class="marker-tick"></span>
            <span class="marker-label">200</span>
          </span>
          <span class="marker" :class="{ 'marker-active': ratio >= 300 }">
            <span class="marker-tick"></span>
            <span class="marker-label">300</span>
          </span>
          <span class="marker" :class="{ 'marker-active': ratio >= 400 }">
            <span class="marker-tick"></span>
            <span class="marker-label">400</span>
          </span>
          <span class="marker" :class="{ 'marker-active': ratio >= 500 }">
            <span class="marker-tick"></span>
            <span class="marker-label">500</span>
          </span>
        </div>

        <!-- Slider personalizado -->
        <div class="custom-slider-container px-1 mb-4">
          <v-slider 
            v-model="ratio" 
            min="1" 
            max="500" 
            always-dirty
            hide-details
            class="custom-slider"
            color="#f05a24"
            track-color="#E0E0E0"
            thumb-color="#f05a24"
          >
          </v-slider>
        </div>

        <!-- Leyenda -->
        <div class="d-flex justify-space-between align-center px-1 mt-2">
          <div class="d-flex align-center">
            <span class="legend-dot legend-dot-blue"></span>
            <span class="legend-text">{{ $t('components.views.settings.posting_rules.post_radius.near') }}</span>
          </div>
          <div class="d-flex align-center">
            <span class="legend-dot legend-dot-orange"></span>
            <span class="legend-text">{{ $t('components.views.settings.posting_rules.post_radius.far') }}</span>
          </div>
        </div>

        <!-- Mensaje informativo y botón -->
        <div class="d-flex align-center justify-space-between mt-4">
          <div class="info-alert flex-grow-1 mr-4">
            <div class="d-flex align-start">
              <v-icon color="#FF9800" size="20" class="mr-2 flex-shrink-0">fa-solid fa-truck</v-icon>
              <span class="info-text">
                {{ $t('components.views.settings.posting_rules.post_radius.trip_will_be_published') }}
                <strong class="info-highlight">{{ ratio }} km</strong>
              </span>
            </div>
          </div>

          <!-- Botón de guardar -->
          <v-btn
            color="#0b0045"
            dark
            large
            @click.stop="saveCounterOffer()"
            class="rounded-lg px-8 flex-shrink-0"
            elevation="2"
            :disabled="!valida"
          >
            <v-icon small class="mr-2">fa-solid fa-save</v-icon>
            {{ $t('components.views.settings.posting_rules.post_radius.save_button') }}
          </v-btn>
        </div>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import validaciones from "@/plugins/validate";
export default {
  data() {
    return {
      ...validaciones,
      percent: "",
      ratio: "",
      update: true,
      id: 0,
      valida: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    idCompany() {
      if (this.user !== undefined) {
        let unlockUser = JSON.parse(this.user);
        return unlockUser.user.idCompany;
      }
    },
    typeUser() {
      if (this.user !== undefined) {
        let unlockUser = JSON.parse(this.user);
        return unlockUser.user.typeUser;
      }
    },
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    ...mapActions("loader", ["showLoader"]),

    decrement() {
      if (this.ratio > 1) {
        this.ratio--;
      }
    },

    increment() {
      if (this.ratio < 500) {
        this.ratio++;
      }
    },

    async loadPostRadius() {
      await this.axios
        .get(`/PerimeterOffer/Perimeter/Get/${this.idCompany}`)
        .then((data) => {
          this.ratio = data.data.data.percentage / 1000;
          if (this.ratio) {
            this.update = true;
          }
        })
        .catch((error) => {});
    },

    async saveCounterOffer() {
      this.showLoader({
        show: true,
      });

      let ratio = parseInt(this.ratio) * 1000;

      if (!this.update) {
        await this.axios
          .post(`/CounterOffer/Save/${ratio}`)
          .then(() => {
            this.showSnack({
              text: this.$t("components.views.settings.posting_rules.post_radius.save_success"),
              title: this.$t("components.views.settings.posting_rules.post_radius.success"),
              name: "success",
            });
          })
          .catch((error) => {
            this.showSnack({
              text: error.response.data,
              title: this.$t("components.views.settings.posting_rules.post_radius.save_error"),
              name: "error",
            });
          })
          .finally(() => {
            this.showLoader({
              show: false,
            });
          });
      } else {
        let params = {
          idCompany: this.idCompany,
          percentage: ratio,
        };

        await this.axios
          .put(`/PerimeterOffer/Perimeter/Update`, params)
          .then(() => {
            this.showSnack({
              text: this.$t("components.views.settings.posting_rules.post_radius.save_success"),
              title: this.$t("components.views.settings.posting_rules.post_radius.success"),
              name: "success",
            });
          })
          .catch((error) => {
            this.showSnack({
              text: error.response.data,
              title: this.$t("components.views.settings.posting_rules.post_radius.save_error"),
              name: "error",
            });
          })
          .finally(() => {
            this.showLoader({
              show: false,
            });
          });
      }
    },
  },
  metaInfo() {
    return {
      title: this.$t(
        "components.views.settings.posting_rules.post_radius.publication_radius"
      ),
    };
  },
  mounted() {
    this.loadPostRadius();
  },
};
</script>

<style scoped lang="scss">
@import './PostRadiusStyle.scss';
</style>

<style scoped>
/* Estilos específicos del v-slider */
.custom-slider >>> .v-slider {
  margin-left: 0;
  margin-right: 0;
}

.custom-slider >>> .v-slider__track-container {
  height: 6px;
  border-radius: 3px;
}

.custom-slider >>> .v-slider__track-background {
  background: #E8E8E8 !important;
  border-radius: 3px;
}

.custom-slider >>> .v-slider__track-fill {
  background: linear-gradient(90deg, #0b0045 0%, #3d1a7a 30%, #f05a24 70%, #ff8c5a 100%) !important;
  border-radius: 3px;
}

.custom-slider >>> .v-slider__thumb {
  width: 28px;
  height: 28px;
  background-color: #f05a24 !important;
  border: 5px solid white;
  box-shadow: 0 3px 10px rgba(240, 90, 36, 0.35);
  transition: all 0.2s ease;
}

.custom-slider >>> .v-slider__thumb::before {
  display: none;
}

.custom-slider >>> .v-slider__thumb:hover {
  transform: scale(1.08);
  box-shadow: 0 4px 14px rgba(240, 90, 36, 0.45);
}

.custom-slider >>> .v-slider__thumb-container {
  transition: none;
}
</style>